import { flagApis } from '@shared/apis';
import { genericMutation, genericMutationWithId, genericQueryWithParams } from './generics';

export const useSearchFlags = genericQueryWithParams<flagApis.SearchFlags>(flagApis.searchFlags);

export const useCloseMultipleFlags = genericMutation<flagApis.CloseMultipleFlags>(
  flagApis.closeMultipleFlags
);

export const useGetNoOfFlagsByFlagTypes = genericQueryWithParams<flagApis.GetNoOfFlagsByFlagTypes>(
  flagApis.getNoOfFlagsByFlagTypes
);

export const useSearchFlagsForLinearChart =
  genericQueryWithParams<flagApis.SearchFlagsForLinearChart>(flagApis.searchFlagsForLinearChart);

export const useGetUsersWithFlags = genericQueryWithParams<flagApis.GetUsersWithFlags>(
  flagApis.getUsersWithFlags
);

export const useGetUserFlagsDetails = genericQueryWithParams<flagApis.GetUserFlagsDetails>(
  flagApis.getUserFlagsDetails
);

export const useGetMentorFlags = genericQueryWithParams<flagApis.GetMentorFlags>(
  flagApis.getMentorFlags
);

export const useGetMentorFlagsNo = genericQueryWithParams<flagApis.GetMentorFlagsNo>(
  flagApis.getMentorFlagsNo
);

export const useAddMentorCommentToFlag = genericMutationWithId<flagApis.AddMentorCommentToFlag>(
  flagApis.addMentorCommentToFlag
);
